import { render, staticRenderFns } from "./VAdminSecurityGroupCard.vue?vue&type=template&id=81361efe"
import script from "./VAdminSecurityGroupCard.vue?vue&type=script&lang=js"
export * from "./VAdminSecurityGroupCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports